import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, InputNumber, SelectProps, Table, Tag, Row, Col, Select, Form, Input, Popconfirm, DatePicker, Modal} from "antd";
import Colors from "../../../styles/Colors";
import {BiArrowBack, BiPencil, BiPlus, BiRefresh, BiSave, BiSend, BiTrash} from "react-icons/bi";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye, BsReceipt} from "react-icons/bs";
import ComandaFinalizadaModal from  "./ComandaPerEnviarModal";
import {format} from "date-fns";
import toast, {Toaster} from "react-hot-toast";
import {GetComandaId} from "../../../dao/menudesign/comandes/GetComandaId";
import { GetComandaAfegitId } from '../../../dao/menudesign/comandes/GetComandaAfegitId';
import {NumberOutlined} from "@ant-design/icons";
import {User} from "../../../model/root/User";
import UsuarisList from "../components/UsuarisList";
import { PostComandaModificacio } from '../../../dao/menudesign/comandes/PostComandaModificacio';
import {QuestionCircleOutlined} from "@ant-design/icons";
import dayjs from "dayjs";
import { PutProposta } from '../../../dao/menudesign/comandes/PutProposta';
import Proposta from "../../../model/menudesign/comandes/Proposta";



const Comandes = () => {
    const titol: string = "Editar Comanda";
   
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const permisEditarComanda = user.pagines.find(pagina => pagina.descripcio === "Comanda Final" && pagina.tipus === 1);

    const navigate = useNavigate();
    const {id} = useParams();
    const query = new URLSearchParams(location.search);
    const isViewMode = query.get("view") === "true";
    const [form] = Form.useForm();
    const [coleccio, setDades] = useState<any[]>([]);
    const [participants, setParticipants] = useState<any[]>([]);
    const [altres, setAltres] = useState<{ value: number; label: string; }[]>([]);
    const [elementSelected, setElementSelected] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);
    const [estat, setEstat] = useState(Number);

    useEffect(() => {
        if(isLoggedIn){
            handleLoadingChange(true)
            checkDades();
        }

    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetComandaId(page, id+"");

        setEstat(dades.comanda.estat);

        const plats = dades.plats?.map((p: any) => ({
        ...p,
        ingredients: (p.ingredients || []).map((ing: any) => ({
            ...ing,
            id_menu_plat: p.id_menu_plat,
            afegit: ing.modificacio || 0,
            totalFinal: ing.total + (ing.modificacio || 0)
        }))
        })) || [];

        const platAltres = dades.altres.map((element : any) => ({
            value: element.id,
            label: element.nom,
        }));
        setDades(plats);
        setParticipants(dades.participants);
        setAltres(platAltres);

        const dadesAfegit = await GetComandaAfegitId(page, Number(id));
        if (dadesAfegit?.length > 0) {
            const dadesTransformades = dadesAfegit.map((item: any) => ({
                id_ingredient: item.id_ingredient,
                variacio: item.variacio,
                dia: item.dia ? dayjs(item.dia, "YYYY-MM-DD") : null,
                mesura: item.mesura,
            }));

            form.setFieldsValue({ variacio_plat: dadesTransformades });
        }

        const allKeys = dades.plats?.map((item: any) => item.id) || [];
        console.log(allKeys);
        setExpandedRowKeys(allKeys);
        console.log(JSON.stringify(dades));
        handleLoadingChange(false);
    }

    const handleAfegitChange = (value: number | null, record: any, platId: number) => {
        const updated = coleccio.map((plat) => {
            if (plat.id_menu_plat === platId) {
                return {
                    ...plat,
                    ingredients: plat.ingredients.map((ing: any) => {
                        if (ing.id === record.id) {
                            const afegitValue = value || 0;
                            return {
                                ...ing,
                                afegit: afegitValue,
                                totalFinal: ing.total + afegitValue
                            };
                        }
                        return ing;
                    })
                };
            }
            return plat;
        });
        setDades(updated);
    };

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        //await Deleteany(id, page);
        await checkDades();
    }

    function afegirElement(element: any) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElement(element: any) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: any[]) {
        if (elements?.length > 0) {
            const uniqueNonEmptyNames = Array.from(new Set(elements
                .map((element) => element.escola)
                .filter((name) => name !== '')));

            const ingredientNames = uniqueNonEmptyNames.map((name) => ({
                text: name,
                value: name,
            }));

            setNomFiltres(ingredientNames);
        }
    }

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'ID'
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            title: 'Nom Plat',
            render: (estat, ele) => (
                <Tag color={Colors.colors.color1}>{estat}</Tag>
            )
        },
        {
            key: 'dia_setmana',
            dataIndex: 'dia_setmana',
            title: 'Dia Setmana'
        },
        {
            key: 'data',
            dataIndex: 'data',
            title: 'Data'
        },
    ];

    const columnsAltres: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'ID'
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            title: 'Ingredient'
        },
        {
            key: 'cuina',
            dataIndex: 'cuina',
            title: 'Precisa Cuina?',
            render: (estat, ele) => (
                <Tag color={estat === "1" ? Colors.colors.color2 : Colors.colors.color5}>{estat === "1" ? "SÍ" : "NO"}</Tag>
            )
        },
        {
            key: 'accions', dataIndex: 'accions',
            title: 'Afegir',
            render: (estat, ele) => (
                <InputNumber style={{backgroundColor: Colors.colors.color6}}
                             defaultValue={0.0} min={0} step={0.1}  addonAfter={ele.mesura}/>
            )
        },
        {
            key: 'accions', dataIndex: 'accions',
            title: 'Afegit',
            render: (estat, ele) => (
                <InputNumber defaultValue={0.0}  step={0.1} addonBefore="+" addonAfter={ele.mesura} disabled={isViewMode}/>
            )
        },
    ];

    const getColumnsIngredients = (platId: number): ColumnsType<any> => [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'ID'
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            title: 'Ingredient'
        },
        {
            key: 'cuina',
            dataIndex: 'cuina',
            title: 'Precisa Cuina?',
            render: (estat, ele) => (
                <Tag color={estat === "1" ? Colors.colors.color2 : Colors.colors.color5}>
                    {estat === "1" ? "SÍ" : "NO"}
                </Tag>
            )
        },
        {
            key: 'estimat',
            dataIndex: 'total',
            title: 'Estimat',
            render: (_, ele) => (
                <InputNumber disabled value={ele.total} min={0} step={0.1} addonAfter={ele.mesura}/>
            )
        },
        {
            key: 'afegit',
            dataIndex: 'afegit',
            title: 'Afegit',
            render: (_, record) => (
                <InputNumber
                    style={{backgroundColor: Colors.colors.color6}}
                    value={record.afegit}
                    step={0.1}
                    onChange={(value) => handleAfegitChange(value, record, platId)}
                    addonBefore="+"
                    addonAfter={record.mesura}
                    disabled={isViewMode}
                />
            )
        },
        {
            key: 'totalFinal',
            dataIndex: 'totalFinal',
            title: 'Total',
            render: (_, record) => (
                <InputNumber
                    disabled
                    value={record.totalFinal}
                    step={0.1}
                    addonAfter={record.mesura}
                    
                />
            )
        }
    ];


    const columnsParticpants: ColumnsType<any> = [
        {
            key: 'dia',
            dataIndex: 'dia',
            title: 'Dia'
        },
        {
            key: 'escola',
            dataIndex: 'escola',
            title: 'Escola'
        },
        {
            key: 'qInfantil',
            dataIndex: 'qInfantil',
            title: 'Alumnes Infantil',
            render: (estat, ele) => (
                <Tag color={Colors.colors.color2}>{estat}</Tag>
            )
        },
        {
            key: 'qPrimaria',
            dataIndex: 'qPrimaria',
            title: 'Alumnes Primaria',
            render: (estat, ele) => (
                <Tag color={Colors.colors.color3}>{estat}</Tag>
            )
        },
        {
            key: 'qAdult',
            dataIndex: 'qAdult',
            title: 'Adults',
            render: (estat, ele) => (
                <Tag color={Colors.colors.color4}>{estat}</Tag>
            )
        },
        {
            key: 'Totals',
            dataIndex: 'Totals',
            title: 'Totals',
            render: (estat, ele) => (
                <Tag color={Colors.colors.color5}>{ele.qInfantil + ele.qPrimaria + ele.qAdult}</Tag>
            )
        }
    ];

    const tableProps: TableProps<any> = {
        loading
    };

    const onChange: TableProps<any>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };


    function handleBack() {
        navigate(`/menudesign/propostes`);
    }

    async function handleGuardar() { 
        
            const formValues = await form.validateFields(); 
            const platsModificats = coleccio.flatMap((plat) =>
            (plat.ingredients || []).map((ing: any) => ({
                id_menu_plat: ing.id_menu_plat,
                id_ingredient: ing.id,
                variacio: ing.afegit,
                dia: '',
            }))
        );
            const altresModificacions = 
                formValues?.variacio_plat?.map((item: any) => ({ 
                    id_menu_plat: '', 
                    id_ingredient: item.id_ingredient, 
                    variacio: item.variacio,
                    dia:  item.dia.format("YYYY-MM-DD"),
 
                })) || []; 

            const comanda_modificacio = [...platsModificats, ...altresModificacions]; 
            
            setLoading(true); 

            await PostComandaModificacio(page, comanda_modificacio, Number(id) , userId); 
            toast.success("Comanda guardada correctament!"); 
            setLoading(false); 
        
            
        
    }
    async function handleValidar() {
        const formValues = await form.validateFields(); 
        const platsModificats = coleccio.flatMap((plat) =>
            (plat.ingredients || []).map((ing: any) => ({
                id_menu_plat: ing.id_menu_plat,
                id_ingredient: ing.id,
                variacio: ing.afegit,
                dia: '',
            }))
        );
        const altresModificacions = 
            formValues?.variacio_plat?.map((item: any) => ({ 
                id_menu_plat: '', 
                id_ingredient: item.id_ingredient, 
                variacio: item.variacio,
                dia:  item.dia.format("YYYY-MM-DD"),
 
                })) || []; 

        const comanda_modificacio = [...platsModificats, ...altresModificacions]; 
            
        setLoading(true); 

        await PostComandaModificacio(page, comanda_modificacio, Number(id) , userId);
        setLoading(false); 
        setNouElement(!nouElement);
    }
    async function handleEnviar() {
        const formValues = await form.validateFields(); 
        const platsModificats = coleccio.flatMap((plat) => 
            plat.ingredients 
                .map((ing: any) => ({ 
                    id_menu_plat: ing.id_menu_plat, 
                    id_ingredient: ing.id, 
                    variacio: ing.afegit, 
                    dia: '', 
                 })) ); 
        const altresModificacions = 
            formValues?.variacio_plat?.map((item: any) => ({ 
                id_menu_plat: '', 
                id_ingredient: item.id_ingredient, 
                variacio: item.variacio,
                dia:  item.dia.format("YYYY-MM-DD"),
 
                })) || []; 

        const comanda_modificacio = [...platsModificats, ...altresModificacions]; 
            
        setLoading(true); 

        await PostComandaModificacio(page, comanda_modificacio, Number(id) , userId);
        setLoading(false);

        const proposta = new Proposta();
        proposta.id = Number(id);
        proposta.estat = 1;
        await PutProposta(page, proposta, userId);

        Modal.success({
            title: "Comanda enviada correctament",
            });
        navigate(`/menudesign/propostes`);
    }
    const expandedRowRender2 = (plat: any) => {
        return (
            <>
                <br/>
                <Table
                    style={{paddingLeft: "10%"}}
                    {...tableProps}
                    pagination={false}
                    onChange={onChange}
                    size={"small"}
                    columns={getColumnsIngredients(plat.id_menu_plat)}
                    dataSource={plat.ingredients}
                    rowKey={(record) => `${plat.id_menu_plat}_${record.id}`}
                />
                <br/>
            </>
        );
    };



    if (isLoggedIn) {
        return (
            <div>
                <NavBar />
                <Toaster/>
                <div className="general">
                <Card bordered className="elemento">
                    <div
                    className="actionButtons"
                    style={{ alignItems: "center", display: "flex" }}
                    >
                    <Button
                        title="Enrere"
                        style={{ backgroundColor: Colors.colors.color2 }}
                        onClick={handleBack}
                    >
                        <BiArrowBack />
                    </Button>
                    {!isViewMode && (
                        <>
                    <Button
                        title="Guardar"
                        style={{ backgroundColor: Colors.colors.color4 }}
                        onClick={handleGuardar}
                    >
                        <BiSave />
                    </Button>

                    <Button
                        title={estat === 0 ? "Enviar" : "Validar"}
                        style={{ backgroundColor: Colors.colors.color5 }}
                        onClick={estat === 0 ? handleEnviar : handleValidar}
                        >
                        <BiSend />
                        
                    </Button>
                    </>
                    )}
                    </div>

                    <h4 className="titol">PARTICIPANTS</h4>

                    {visible && (
                    <>
                        <Table
                        {...tableProps}
                        pagination={false}
                        onChange={onChange}
                        columns={columnsParticpants}
                        dataSource={participants}
                        />

                        <br />

                        <h4 className="titol">COMANDA</h4>
                        <hr />

                        <Table
                            {...tableProps}
                            pagination={false}
                            onChange={onChange}
                            columns={columns}
                            expandable={{
                                defaultExpandAllRows: true,
                                expandedRowKeys: expandedRowKeys,
                                expandedRowRender: (record) => expandedRowRender2(record),
                                rowExpandable: (record) => record.ingredients !== null,
                            }}
                            dataSource={coleccio}
                        />

                        <br />

                        <h4 className="titol">Altres ingredients</h4>
                        <hr />

                        <div className="general" >
                            <Card bordered style={{backgroundColor: 'white'}} className="elemento">
                        <Form form={form} layout="vertical">
                        <Form.List name="variacio_plat">
                            {(fields, { add, remove }, { errors }) => (
                            <>
                                {fields.map(({ key, name, ...restField }) => (
                                <Row key={key} gutter={[8, 8]}>
                                    <Col span={8}>
                                        <Form.Item
                                            {...restField}
                                            label="Ingredient"
                                            name={[name, "id_ingredient"]}
                                            rules={[
                                            {
                                                required: true,
                                                message: "Aquest camp es obligatori",
                                            },
                                            ]}
                                            style={{marginRight:'10%'}}
                                        >
                                            <Select
                                            disabled={isViewMode}
                                            showSearch
                                            optionFilterProp="label"
                                            options={altres}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item
                                            {...restField}
                                            label="Afegit"
                                            name={[name, "variacio"]}
                                            rules={[
                                            {
                                                required: true,
                                                message: "Aquest camp es obligatori",
                                            },
                                            ]}
                                            style={{marginRight:'10%'}}
                                        >
                                            <InputNumber
                                            disabled={isViewMode}
                                            style={{ backgroundColor: Colors.colors.color6, width:'100%'}}
                                            min={0}
                                            step={0.1}
                                            addonAfter="  "
                                            addonBefore="+" 
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            {...restField}
                                            label="Dia"
                                            name={[name, "dia"]}
                                            rules={[
                                            {
                                                required: true,
                                                message: "Aquest camp es obligatori",
                                            },
                                            ]}
                                            style={{marginRight:'10%'}}
                                        >
                                            <DatePicker
                                            disabled={isViewMode}
                                            format="DD/MM/YYYY"
                                            style={{ width: "100%" }}
                                            />
                                        </Form.Item>
                                    </Col>

                                    {fields.length > 0 && (
                                        <div style={{justifyItems: 'center', alignItems:'center', display:'flex'}}>
                                        
                                            <Popconfirm
                                            title="Eliminant"
                                            description="Vols eliminar definitivament aquest element?"
                                            onConfirm={() => remove(name)}
                                            icon={
                                                <QuestionCircleOutlined style={{ color: "red" }} />
                                            }
                                            >
                                                <MinusCircleOutlined
                                                    className="dynamic-delete-button"
                                                    style={{ alignItems: "center", color: "red" }}
                                                />
                                            </Popconfirm>
                                        
                                        </div>
                                    )}
                                </Row>
                                ))}

                                <Form.Item>
                                    <Button
                                        type="dashed"
                                        onClick={() => add()}
                                        style={{
                                        width: "25%",
                                        borderColor: Colors.colors.color2,
                                        padding: "5px",
                                        }}
                                        icon={<PlusOutlined />}
                                    >
                                        Afegeix ingredient
                                    </Button>
                                <Form.ErrorList errors={errors} />
                                </Form.Item>
                            </>
                            )}
                        </Form.List>
                        </Form>
                        </Card>
                        </div>
                    </>
                    )}
                    <div
                    style={{ alignItems: "center", display: "flex", justifyContent:'center' }}
                    >
                    <Button
                        title="Enrere"
                        style={{ backgroundColor: Colors.colors.color2 }}
                        onClick={handleBack}
                    >
                        <BiArrowBack />
                    </Button>
                    {!isViewMode && (
                        <>
                    <Button
                        title="Guardar"
                        style={{ backgroundColor: Colors.colors.color4 }}
                        onClick={handleGuardar}
                    >
                        <BiSave />
                    </Button>

                    <Button
                        title={estat === 0 ? "Enviar" : "Validar"}
                        style={{ backgroundColor: Colors.colors.color5 }}
                        onClick={estat === 0 ? handleEnviar : handleValidar}
                        >
                        <BiSend />
                        
                    </Button>
                    </>
                    )}
                    </div>
                </Card>

                {nouElement && (
                    <ComandaFinalizadaModal
                    element={id+""}
                    onClose={handleCloseModal}
                    visible={nouElement}
                    />
                )}
                
                </div>
            </div>
            );

        } else {
        return (
            <Login/>
        );
    }
};
export default Comandes;
